import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { DataProvider } from './context/DataContext';
import CustomerStore from './pages/CustomerStore';
import AdminPanel from './pages/AdminPanel';
import BlogPage from './pages/BlogPage';

function App() {
  return (
    <DataProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<CustomerStore />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;